import { Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "components/layout/Label";
import { useState } from "react";

export function SendToAuthorities({hasBeenPreviousSendt, isReadOnly, isStateChanged, handleCheckedChange}) {

    const [sendToAuthorities, setSendToAuthorities] = useState(false);

    function handleOnChecked(e) {
        setSendToAuthorities(e.value);
        handleCheckedChange(e)
    }

    function shouldShowReportEdit() {
        return !isReadOnly && isStateChanged.current;
    }

    return (
        <> 
        {hasBeenPreviousSendt && !isStateChanged.current &&
            <Label>Sendt til Sjøfartsdirektoratet</Label>
        }
        {shouldShowReportEdit() && (
            <>
                <Checkbox 
                    label={"Send til Sjøfartsdirektoratet"} 
                    disabled={isReadOnly} 
                    value={sendToAuthorities} 
                    onChange={handleOnChecked} />
            </>
        )}            
        </>
    );
}